import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
const usageTracker = createTracker({
  events
});
export const trackSubmit = stageName => {
  usageTracker.track('revenuestagechangesubmit', {
    stageName
  });
};
export const logPageView = payload => {
  usageTracker.track('Pageview', Object.assign({}, payload, {
    screen: `customer-data-properties`
  }));
};